// extracted by mini-css-extract-plugin
export default {"root":"FabricFacetFiltersDropdowns__root___Cy18u","items":"FabricFacetFiltersDropdowns__items___rrvIA"};